module.exports = __webpack_public_path__ + "img/vertical_3_1_8003.725181a5.png";